// TopWallet — 4 card illustrations (WebP-first with PNG fallback).
// Same exported API as before (TOPWALLET_SVG_BY_ID dictionary).
import React from "react";

const Pic = ({ name, alt }) => (
  <picture>
    <source srcSet={`/topwallet/${name}.webp`} type="image/webp" />
    <img
      src={`/topwallet/${name}.png`}
      alt={alt}
      loading="lazy"
      decoding="async"
      style={{
        width: "100%",
        height: "100%",
        display: "block",
        objectFit: "cover",
        objectPosition: "center",
      }}
    />
  </picture>
);

export const SvgCarteras = () => <Pic name="carteras" alt="REBEL TopWallet — Carteras Digitales" />;
export const SvgRedes = () => <Pic name="redes" alt="REBEL TopWallet — Redes Blockchain" />;
export const SvgSeguridad = () => <Pic name="seguridad" alt="REBEL TopWallet — Seguridad Digital" />;
export const SvgDefi = () => <Pic name="defi" alt="REBEL TopWallet — DeFi & Transferencias" />;

export const TOPWALLET_SVG_BY_ID = {
  carteras: SvgCarteras,
  redes: SvgRedes,
  seguridad: SvgSeguridad,
  defi: SvgDefi,
};
